import * as React from "react";
import {Component} from "react";
import { connect } from "react-redux";

import Invoice from "../../screens/Invoice";

import {getInvoices, invoicepageSelected} from "./action";

class InvoiceContainer extends Component {
  render() {
    return <Invoice 
    getInvoices={this.props.getInvoices}
    invoicepageSelected={this.props.invoicepageSelected}
    invoiceList={this.props.invoiceList}
    invoiceListCount={this.props.invoiceListCount}
    />;
  }
}
function bindAction(dispatch) {
  return {
    getInvoices: (value) => {
      dispatch(getInvoices(value));
    },
    invoicepageSelected:(value)=>{
        dispatch(invoicepageSelected(value));
    },
  };
}

const mapStateToProps = (state) => {
  return {
    invoiceList: state.InvoiceReducer.invoiceList,
    invoiceListCount:state.InvoiceReducer.invoiceListCount,
  };
};

export default connect(mapStateToProps, bindAction)(InvoiceContainer);
